import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandBriefsPage = loadAsyncComponent(() => import('./Container'), 'page');
